(function () {
  function initArchive(root) {
    if (root.getAttribute('data-archive-initialized') === 'true') return;
    root.setAttribute('data-archive-initialized', 'true');

    var grid = root.querySelector('[data-grid]');
    var loadBtn = root.querySelector('[data-load-more]');
    if (!grid) return;

    // — Tag filters: multi-select, client-side (native /tagged/ only
    // supports one tag at a time, and cards may come from Load More too). —
    var tagButtons = root.querySelectorAll('[data-tag-btn]');
    var selectedTags = [];

    function updateTagButtonStates() {
      tagButtons.forEach(function (btn) {
        var tag = btn.getAttribute('data-tag');
        var isAll = tag === '';
        var active = isAll ? selectedTags.length === 0 : selectedTags.indexOf(tag) > -1;
        btn.classList.toggle('is-active', active);
      });
    }

    function updateTagsToggleLabel() {
      var label = tagsToggle && tagsToggle.querySelector('[data-tags-toggle-label]');
      if (!label) return;
      if (selectedTags.length === 0) {
        label.textContent = label.getAttribute('data-all-label') || label.textContent;
      } else if (selectedTags.length === 1) {
        label.textContent = selectedTags[0];
      } else {
        label.textContent = selectedTags.length + ' selected';
      }
    }

    function applyTagFilter() {
      var cards = grid.querySelectorAll('.eaarch-card');
      cards.forEach(function (card) {
        if (selectedTags.length === 0) {
          card.style.display = '';
          return;
        }
        var cardTags = (card.getAttribute('data-tags') || '').split('|');
        var match = selectedTags.some(function (t) { return cardTags.indexOf(t) > -1; });
        card.style.display = match ? '' : 'none';
      });
    }

    tagButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = btn.getAttribute('data-tag');
        if (tag === '') {
          selectedTags = [];
        } else {
          var idx = selectedTags.indexOf(tag);
          if (idx > -1) selectedTags.splice(idx, 1);
          else selectedTags.push(tag);
        }
        updateTagButtonStates();
        updateTagsToggleLabel();
        applyTagFilter();
      });
    });

    // — Mobile dropdown toggle for the tag list —
    var tagsToggle = root.querySelector('[data-tags-toggle]');
    var tagsPanel = root.querySelector('[data-tags-panel]');
    if (tagsToggle && tagsPanel) {
      var toggleLabelEl = tagsToggle.querySelector('[data-tags-toggle-label]');
      if (toggleLabelEl) toggleLabelEl.setAttribute('data-all-label', toggleLabelEl.textContent);

      tagsToggle.addEventListener('click', function () {
        var isOpen = tagsPanel.classList.toggle('is-open');
        tagsToggle.setAttribute('aria-expanded', String(isOpen));
      });

      document.addEventListener('click', function (event) {
        if (tagsToggle.contains(event.target) || tagsPanel.contains(event.target)) return;
        tagsPanel.classList.remove('is-open');
        tagsToggle.setAttribute('aria-expanded', 'false');
      });
    }

    if (loadBtn) {
      loadBtn.addEventListener('click', function () {
        var url = loadBtn.getAttribute('data-next-url');
        var sectionId = root.getAttribute('data-section-id');
        if (!url || !sectionId) return;

        var separator = url.indexOf('?') > -1 ? '&' : '?';
        loadBtn.disabled = true;
        loadBtn.textContent = loadBtn.getAttribute('data-loading-text') || 'Loading…';

        fetch(url + separator + 'section_id=' + sectionId)
          .then(function (res) {
            if (!res.ok) throw new Error('Load more request failed: ' + res.status);
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-grid]');

            if (newGrid) {
              Array.prototype.slice.call(newGrid.children).forEach(function (card) {
                grid.appendChild(card);
              });
              applyTagFilter();
            }

            var newLoadBtn = doc.querySelector('[data-load-more]');
            if (newLoadBtn) {
              loadBtn.setAttribute('data-next-url', newLoadBtn.getAttribute('data-next-url'));
              loadBtn.disabled = false;
              loadBtn.textContent = loadBtn.getAttribute('data-default-text') || 'Load more';
            } else {
              loadBtn.parentNode.removeChild(loadBtn);
            }
          })
          .catch(function () {
            loadBtn.disabled = false;
            loadBtn.textContent = loadBtn.getAttribute('data-default-text') || 'Load more';
          });
      });
    }
  }

  function init() {
    document.querySelectorAll('[id^="eaarch-"]').forEach(initArchive);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


